import { render, staticRenderFns } from "./FormulationProductSpecificationTab.vue?vue&type=template&id=c8c78168&scoped=true&"
import script from "./FormulationProductSpecificationTab.vue?vue&type=script&lang=js&"
export * from "./FormulationProductSpecificationTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationProductSpecificationTab.vue?vue&type=style&index=0&id=c8c78168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c78168",
  null
  
)

export default component.exports